import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiUsers, FiUserCheck } from "react-icons/fi";
import UserAvatar from "../UserAvatar";
import "./widgets.css";

const OnlineFriendsWidget = ({ friends }) => {
  if (!friends || friends.length === 0) {
    return (
      <motion.div
        className="cbx-widget cbx-widget--friends"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <div className="cbx-widget__header">
          <h3 className="cbx-widget__title">
            <FiUsers className="cbx-widget__title-icon" />
            Online Friends
          </h3>
        </div>
        <div className="cbx-widget__empty">
          <FiUserCheck className="cbx-widget__empty-icon" />
          <p className="cbx-widget__empty-text">No friends online</p>
        </div>
      </motion.div>
    );
  }

  return (
    <motion.div
      className="cbx-widget cbx-widget--friends"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="cbx-widget__header">
        <h3 className="cbx-widget__title">
          <FiUsers className="cbx-widget__title-icon" />
          Online Friends
        </h3>
        <span className="cbx-widget__badge">{friends.length}</span>
      </div>

      <div className="cbx-friends-list">
        {friends.map((friend) => (
          <Link
            key={friend._id}
            to={`/profile/${friend._id}`}
            className="cbx-friend-item"
          >
            <div className="cbx-friend-avatar">
              <UserAvatar user={friend} size="medium" />
              <span className="online-dot" />
            </div>
            <div className="cbx-friend-info">
              <h4 className="cbx-friend-name">{friend.name}</h4>
              <p className="cbx-friend-status">
                {friend.professionalRole || "Online"}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </motion.div>
  );
};

export default OnlineFriendsWidget;
